import React, { useContext, useEffect } from 'react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import UserRegistrationHead from '@Scenes/UserRegistrationScenes/UserRegistrationScene/UserRegistrationHead'
import UserRegistrationForm from '@Scenes/UserRegistrationScenes/UserRegistrationScene/UserRegistrationForm'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'

const UserRegistrationScene = () => {
    const { uiStore } = useContext(StoresContext)

    useEffect(() => {
        uiStore.setOnLoginPage(false)
        analyticsSendPage('user_registration')
    }, [])

    return (
        <>
            <title>User registration</title>
            <main className="user-registration-scene">
                <div className="global-container">
                    <UserRegistrationHead />
                    <UserRegistrationForm />
                </div>
            </main>
        </>
    )
}

export default observer(UserRegistrationScene)
